<template>
  <li
    class="nav-item"
  >
    <a
      :href="favouritesSpaLink"
      class="nav-link"
    >
      {{ $t("favorites") }}
    </a>
  </li>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      favouritesSpaLink: null,
    };
  },
  computed: {
    ...mapState(["study"]),
  },
  mounted() {
    this.favouritesSpaLink = `/spa/to?redirect_uri=/studies/${this.study["id"]}/configuration?tab=favorites`;
  },
};
</script>

<style>
.title {
  margin-top: max(2.5vh, 16px);
  margin-bottom: 2px;
}

.small {
  margin-left: max(0.75vh, 2px);
  color: gray;
}
</style>

<i18n>
{
  "en": {
    "favorites": "Favorites"
  },
  "fr": {
    "favorites": "Favoris"
  },
  "de": {
    "favorites": "Favoriten"
  }
}
</i18n>
